/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar } from "graphql-jsx";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  id: string;
  typeTitle: string;
  value: string;
  languageCode: string;
}>;

export const UpdateGenreTitleRelation = async (option: Option) => {
  const $id = <Variable name="id" scalar={<UuidScalar />} value={option.id} />;
  const $typeTitle = <Variable name="typeTitle" scalar={<StringScalar />} value={option.typeTitle} />;
  const $value = <Variable name="value" scalar={<StringScalar />} value={option.value} />;
  const $languageCode = <Variable name="language_code" scalar={<IdScalar />} value={option.languageCode} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_GENRE_TITLE">
      <SelectionSet
        name="updateGenre_title"
        alias="updateGenreTitle"
        argument={{
          where: {
            id: $id
          },
          data: {
            type_genre_title: $typeTitle,
            value: $value,
            language: {
              connect: {
                language_code: $languageCode
              }
            }
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateGenreTitle: {
      id: string;
    };
  }>;

  return await clients.genre.request<Data>(query, variables);
};
